import { Link } from '@change/ds-core-ui';
import { MapAttribution } from '@change/ds-maps';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocalPageData } from '#src/app/pages/local/details/pageContext';

import { DecisionMakersSection } from './components/DecisionMakersSection';
import { FilterablePetitionsSection } from './components/FilterablePetitionsSection';
import { LocalBreadcrumbs } from './components/LocalBreadcrumbs';
import { MostSigned, MostSignedListItem } from './components/MostSignedTopics';
import { PetitionUpdatesSection } from './components/PetitionUpdatesSection';
import { StepCTA } from './components/StepCTA';
import { VictoriousPetitionsSection } from './components/VictoriousPetitionsSection';

export const PageBody: React.FC = () => {
	const {
		data: { displayName, popularTags },
	} = useLocalPageData();
	const { translate } = useI18n();

	return (
		<div className="flex flex-col gap-16 py-16">
			<FilterablePetitionsSection />
			<MostSigned
				title={translate('corgi.local.top_tags.title', { location: displayName })}
				description={translate('corgi.local.top_tags.subheading')}
			>
				{popularTags.slice(0, 4).map((tag) => (
					<MostSignedListItem
						key={tag.id}
						title={tag.name}
						signatureCount={tag.signatureCountLocalized || ''}
						link={`/topic/${tag.slug}?source_location=local_page_most_signed_topics`}
					/>
				))}
			</MostSigned>
			<DecisionMakersSection />
			<PetitionUpdatesSection />
			<VictoriousPetitionsSection />
			<StepCTA />
			<div className="space-y-6">
				<MapAttribution
					attributionLabel={
						// TODO (CHANGE-76576): This should be added to translation strings, but is only
						// en0-US for now
						<div>
							Maps was provided by{' '}
							<Link
								data-qa="topic-map-attribution-open-map-link"
								href="https://openmaptiles.org/"
								target="_blank"
								variant="primary"
							>
								© OpenMapTiles
							</Link>{' '}
							<Link
								data-qa="topic-map-attribution-contributors-link"
								href="https://www.openstreetmap.org/copyright"
								target="_blank"
								variant="primary"
							>
								© OpenStreetMap contributors
							</Link>
						</div>
					}
				/>
				<LocalBreadcrumbs />
			</div>
		</div>
	);
};
